<template>
  <div class="download">
      <h1 class="active">Downloads</h1>
        <ul class="dul">
            <li class="list">
                <div class="til">Windows</div>
                <a href="https://bmc.xyz/l/6EApOrNgM" target="_blank" class="primary btn-submit">Windows Download</a>
            </li>
            <li class="list">
                <div class="til" >Mac OS</div>
                <a href="https://bmc.xyz/l/KibsBGtpd" target="_blank" class="primary btn-submit">Mac Os Download</a>
            </li>
            <li class="list">
                <div class="til" >Linux</div>
                <a href="https://bmc.xyz/l/HCQ0NO48r" target="" class="primary btn-submit">Linux Download</a>
               
            </li>
        </ul>
    </div>
</template>
<script type="text/javascript">
    import { Auth, firestore } from '../main'
    export default {
        name: 'auth',
        methods: {},
    }
</script>

<style type="text/css" scoped>
    .list {
        padding: 10px;
        height: 200px;
        text-align: center;
        width: 200px;
        margin: 20px;
        background: #1E292D;
    }
.til{
        height: 70%;
    font-size: 30px;
    line-height: 5em;
    color:#eee;
}
    .dul {
        display: flex;
        max-width: 1000px;
        margin: auto;
    }

    .download {
        height: 100%;
        justify-content: center;
        align-items: center;
        display: flex;
    }

    .primary {
        padding: 10px 20px;
        border-radius: 4px;
    }
    .title{
        color:#eee;
    }
</style>



// WEBPACK FOOTER //
// src/components/download.vue